import React, { useMemo } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import App from './minjegerside/minjegerside.app/App';
import { AuthRoute } from '../utilities/session-management/auth-route';
import { LoginRoute } from '../utilities/session-management/login-route';
import { LoginCallbackPage, OidcSilentRenewPage } from '../utilities/session-management/oidc/oidc-login-callback-page';
import { Jegeravgiftbetaling } from './betaling/jegeravgiftbetaling';
import { I18nextProvider } from 'react-i18next';
import i18n from '../utilities/i18n';
import { IkkeJeger } from './ikkejeger/ikkejeger';
import { EtterBetaling } from './betaling/etterbetaling/etterbetaling';
import { InternalServerError } from './internalservererror/internalservererror';
import { Landingsside } from './landingsside/landingsside';
import ScrollToTop from './scrolltotop';
import CallbackHandler from '../utilities/CallbackHandler';
import { AuthProvider } from 'react-oidc-context';
import { idPortenUserManager } from '../IdPortenUserManager';

const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
  window.location.replace(`${window.location.origin}/nb`);
};

const AuthenticatedRoutes = () => {
  const routeMatch = useRouteMatch();
  const basePath = useMemo(() => {
    if (routeMatch.path === '/') {
      return '';
    } else {
      return routeMatch.path;
    }
  }, [routeMatch]);
  return (
      <>
        <ScrollToTop />

        <Switch>
          {/* PUBLIC */}
          <Route exact path="/landingsside" component={Landingsside} />

          {/* LOGIN */}
          <LoginRoute path={`${basePath}/:lang/login`} />
          <Route path={`${basePath}/login`}>
            <Redirect to={`${basePath}/${i18n.language}/login`} />
          </Route>

          {/* PROTECTED */}
          <AuthRoute exact path="/ikkejeger" component={IkkeJeger} />
          <AuthRoute exact path="/internalServerError" component={InternalServerError} />

          <AuthRoute exact path={`${basePath}/:lang`} component={App} />
          <AuthRoute exact path={`${basePath}/:lang/betaling`} component={Jegeravgiftbetaling} />
          <AuthRoute exact path={`${basePath}/:lang/betaling/:result`} component={Jegeravgiftbetaling} />

          {/* DEFAULT */}
          <Route path="/">
            <Redirect to={`${basePath}/${i18n.language}`} />
          </Route>
        </Switch>
      </>
  );
};

export const Root = () => (
    <AuthProvider userManager={idPortenUserManager} onSigninCallback={onSigninCallback}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <Switch>

            {/* OIDC */}
            <Route path="/login/idporten/callback" component={CallbackHandler} />
            <Route exact path="/post-signin" component={LoginCallbackPage} />
            <Route exact path="/silent-renew" component={OidcSilentRenewPage} />
            <Route exact path="/error-page" component={OidcSilentRenewPage} />

            {/* PAYMENT */}
            <Route exact path="/betaling/:status" component={EtterBetaling} />

            {/* ROUTES */}
            <Route path="/utenlandsk">
              <AuthenticatedRoutes />
            </Route>

            <Route path="/">
              <AuthenticatedRoutes />
            </Route>

          </Switch>
        </Router>
      </I18nextProvider>
    </AuthProvider>
);